module.exports = __webpack_public_path__ + "static/media/16b.2fa5b031.jpg";